import styled from 'styled-components'
import { Menu } from 'antd'
import { SPACING } from '../../styles/theme'

export const SettingsMenu = styled(Menu)`
  border-right: 0;
  background: transparent;

  .ant-menu-item-selected {
    color: var(--color-text-primary) !important;
  }
`

export const PageContainer = styled.div<{ $isMobile: boolean }>`
  padding: ${(props) => (props.$isMobile ? SPACING.lg : '0')};
  max-width: 1200px;
  margin: 0 auto;
`

export const LayoutContainer = styled.div`
  display: flex;
  gap: 0;
  min-height: calc(100dvh - 64px - 48px);
`

export const SidebarContainer = styled.div`
  width: 220px;
  background-color: var(--color-bg-elevated);
  border-right: 1px solid var(--color-border);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`

export const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  padding: ${SPACING.lg};
  border-bottom: 1px solid var(--color-border);
`

export const ContentArea = styled.div<{ $isMobile: boolean; $hasDesktopSidebar: boolean }>`
  flex: 1;
  padding-left: ${(props) => (props.$isMobile ? '0' : props.$hasDesktopSidebar ? SPACING.xl : '0')};
  padding-top: ${SPACING.lg};
  background: transparent;
  min-width: 0;
`

export const MobileHeader = styled.div`
  margin-bottom: ${SPACING.lg};
`
